module.exports = __webpack_public_path__ + "static/media/Subtract.17ddd83b.svg";